LinksCreate:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"

  post:
    operationId: postLinksCreate
    tags:
      - Link
    summary: リンクの作成
    description: |
      ### ファイル、もしくはフォルダのリンクを作成します。
      
      `target_type`は生成するリンクのタイプです。
      - folder: フォルダリンク
      - file: ファイルリンク
      
      `target_seq`は、リンク生成対象のファイル・フォルダの識別コードです。
      
       > 💡 &nbsp; **Note**  <br><br>
       flag_readable と flag_writable が両方ともNの場合、flag_readable は自動的にYに設定されます。

    security:
      - AccessToken: [ ]

    requestBody:
      $ref: "../openapi/requests.yaml#/CreateLinkRequest"

    responses:
      "200":
        description: ファイルリンク作成成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/CreateLink"
      "default":
        description: ファイルリンク作成失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionfilel"
